
define('text!modules/ui/directives/tree-graph/template.html',[],function () { return '<div class="c-treeGraph u-scrollHorizontallyIfNecessary"></div>';});

